function TrackUtms () {
    if (typeof window !== 'undefined' && window.location.search) {
        let parameters = [];
    
        const UTMS = window.location.search.split('&');
        UTMS.map(parameter => {      
            if (parameter.includes('utm_medium=')) {
                parameter = parameter.substring(parameter.indexOf("=") + 1);
                parameters.push({
                    "utm_medium": parameter
                })
            } else if (parameter.includes('utm_source')) {
                parameter = parameter.substring(parameter.indexOf("=") + 1);
                parameters.push({
                    "utm_source": parameter
                })
            } else if (parameter.includes('utm_campaign')) {
                parameter = parameter.substring(parameter.indexOf("=") + 1);
                parameters.push({
                    "utm_campaign": parameter
                })
            } else if (parameter.includes('utm_content')) {
                parameter = parameter.substring(parameter.indexOf("=") + 1);
                parameters.push({
                    "utm_content": parameter
                })
            } else if (parameter.includes('utm_keyword')) {
                parameter = parameter.substring(parameter.indexOf("=") + 1);
                parameters.push({
                    "utm_keyword": parameter
                })
            } else if (parameter.includes('utm_term')) {
                parameter = parameter.substring(parameter.indexOf("=") + 1);
                parameters.push({
                    "utm_term": parameter
                })
            } else if (parameter.includes('oid')) {
                parameter = parameter.substring(parameter.indexOf("=") + 1);
            } else if (parameter.includes('affid')) {
                parameter = parameter.substring(parameter.indexOf("=") + 1);
            } 
            return null;
        })
        window.localStorage.setItem('utmParameters', JSON.stringify(parameters));
    }
}

export default TrackUtms;
